import React, { ComponentType } from 'react'
import { observer } from 'mobx-react'
import { useApi } from '../api/useApi'
import { useCollectionStore } from '../chat/SearchCollectionsStore'
import { Link } from 'react-router-dom'
import { css } from '@emotion/react'
import { RadioGroup } from '@lib/ui'

// TODO
export const collectionScreenPath = '/admin/collection'

export const CollectionSelector: ComponentType<{
    horizontal?: boolean
}> = observer(({ horizontal } = { horizontal: false }) => {
    const api = useApi()
    const store = useCollectionStore()
    const { items, selected, select } = store

    return (
        <div css={css`
            //width: 100%;
        `}>

            {items?.length === 0 && <span>No collections yet. Create one from <Link to={collectionScreenPath}>
                Collections page
            </Link>.</span>}
            <RadioGroup
                value={selected?.id.toString()}
                horizontal={horizontal}
                onChange={(id) => {
                    select(parseInt(id))
                }}
                options={(items ?? []).map((c) => ({
                    value: c.id.toString(),
                    label: c.name,
                }))}
            />
        </div>
    )
})
